import { useEffect } from 'react';

import AOS from 'aos';

// routes
import Routes from './routes/Routes';

// helpers
// import { configureFakeBackend } from './helpers';

// Themes
//  For Default import Theme.scss
import './assets/scss/theme.scss';
import { ReduxProvider } from 'redux/provider';

const App = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    // configureFakeBackend();
    return (<ReduxProvider>
        <Routes />
    </ReduxProvider>
    );
};

export default App;
